import { render } from "./RouteCard.vue?vue&type=template&id=55aeafa1&scoped=true"
import script from "./RouteCard.vue?vue&type=script&lang=js"
export * from "./RouteCard.vue?vue&type=script&lang=js"

import "./RouteCard.vue?vue&type=style&index=0&id=55aeafa1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55aeafa1"]])

export default __exports__